import { useEffect } from "react";
import type { ConfigurationEntityName, FileEntityName, EntityChangeMessage } from "@repo/services";
import { useConfigurationSignalR } from "~/providers/configuration-signal-r-provider";
import { useFileSignalR } from "~/providers/file-signal-r-provider";

export const useConfigurationSync = (
  entityName: ConfigurationEntityName,
  onChanged?: (data: EntityChangeMessage) => void
) => {
  const api = useConfigurationSignalR();

  useEffect(() => {
    if (!api) return;
    void api.subscribeToEntity(entityName).catch((err) => {
      console.error("ConfigurationSignalR: failed to subscribe to", entityName, err);
    });
    return () => {
      void api.unsubscribeFromEntity(entityName).catch((err) => {
        console.error("ConfigurationSignalR: failed to unsubscribe from", entityName, err);
      });
    };
  }, [api, entityName]);

  useEffect(() => {
    if (!api || !onChanged) return;
    const removeListener = api.onEntityChanged((data) => {
      if (data.typeNameConstant === entityName) {
        onChanged(data);
      }
    });
    return removeListener;
  }, [api, entityName, onChanged]);
};

export const useFileSync = (
  entityName: FileEntityName,
  onChanged?: (data: EntityChangeMessage) => void
) => {
  const api = useFileSignalR();

  useEffect(() => {
    if (!api) return;
    void api.subscribeToEntity(entityName).catch((err) => {
      console.error("FileSignalR: failed to subscribe to", entityName, err);
    });
    return () => {
      void api.unsubscribeFromEntity(entityName).catch((err) => {
        console.error("FileSignalR: failed to unsubscribe from", entityName, err);
      });
    };
  }, [api, entityName]);

  useEffect(() => {
    if (!api || !onChanged) return;
    const removeListener = api.onEntityChanged((data) => {
      if (data.typeNameConstant === entityName) {
        onChanged(data);
      }
    });
    return removeListener;
  }, [api, entityName, onChanged]);
};
